import React from 'react';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import i18n from '../../../../../common/i18n';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetMatchFacts } from '../../../sportradar-widgets/SrWidgetMatchFacts';
import { SrWidgetMatchScoring } from '../../../sportradar-widgets/SrWidgetMatchScoring';

function BetradarMTStatisticsMatchFacts({ matchId }) {
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper title={i18n('betradarMT.statisticTab.factsAndFigures')}>
                <SrWidgetMatchFacts matchId={matchId} />
            </WidgetWrapper>
            <WidgetWrapper title={i18n('betradarMT.statisticTab.scoringProbability')}>
                <SrWidgetMatchScoring matchId={matchId} />
            </WidgetWrapper>
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTStatisticsMatchFacts;
